import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, getToken, setToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchMe = useCallback(async () => {
        if (!getToken()) {
            setUser(null);
            setLoading(false);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            return data;
        } catch {
            setUser(null);
            setToken(null);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchMe();
    }, [fetchMe]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setToken(data.token);
        setUser(data.user);
        return data.user;
    };

    const signup = async (email, name, password, inviteToken) => {
        const { data } = await api.post("/auth/signup", {
            email, name, password,
            ...(inviteToken ? { invite_token: inviteToken } : {}),
        });
        setToken(data.token);
        setUser(data.user);
        return data;
    };

    const logout = () => {
        setToken(null);
        setUser(null);
    };

    const setSession = ({ token, user: newUser }) => {
        setToken(token);
        setUser(newUser);
    };

    return (
        <AuthCtx.Provider value={{ user, loading, login, signup, logout, setSession, refresh: fetchMe }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
